import { NvClusterCtrl } from './nv-cluster.controller';

export default angular.module('nv.cluster', ['nv.shared.modals']).controller('ClusterMasterCtrl', NvClusterCtrl).name;
